<template>
  <div class="container">
    <MenuStudent />
    <div class="student-container">
      <a-layout>
        <a-layout-sider>
          <SideMenuStudent />
        </a-layout-sider>
        <a-layout-content>
          <a-card :bordered="false">
            <router-view />
          </a-card>
        </a-layout-content>
      </a-layout>
    </div>
    <!-- <Footer /> -->
  </div>
</template>

<script>
import MenuStudent from "../components/MenuStudent";
import SideMenuStudent from "../components/SideMenuStudent";
import Footer from "../components/Footer";
export default {
  name: "MenuLayout",
  components: {
    MenuStudent,
    SideMenuStudent,
    Footer,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.container {
  /* background: linear-gradient(
    180deg,
    rgb(59, 143, 238) 7%,
    rgb(155, 216, 243) 100%
  ); */
  background: url(~@assets/theme/xmw/student-bg.png)  #fafcfc;
  background-size: 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
}
.student-container {
  width: 1200px;
  margin: 10px auto;
}
.ant-layout {
  background: transparent;
}
.ant-layout-sider {
  background: #fff;
  text-align: center;
}
.ant-card {
  margin: 0 20px;
  background: #fff;
}
</style>